import * as React from 'react'
import { cn, useImageWithFallback } from '#app/utils/misc.tsx'

interface ImageWithFallbackProps
	extends React.ImgHTMLAttributes<HTMLImageElement> {
	objectKey: string
	preferThumbnail?: boolean
	fallbackSrc?: string
}

export function ImageWithFallback({
	objectKey,
	preferThumbnail = true,
	fallbackSrc,
	alt,
	className,
	...props
}: ImageWithFallbackProps) {
	const { imgSrc, isLoading, error, handleError, handleLoad } =
		useImageWithFallback(objectKey, preferThumbnail)

	return (
		<>
			{isLoading && (
				<div
					className={cn(
						'flex items-center justify-center bg-gray-100',
						className,
					)}
				>
					<div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>
				</div>
			)}
			<img
				src={error && fallbackSrc ? fallbackSrc : imgSrc}
				alt={alt || 'Image'}
				className={cn(isLoading ? 'hidden' : '', className)}
				onError={handleError}
				onLoad={handleLoad}
				{...props}
			/>
		</>
	)
}
